import React, { useEffect, useState, useCallback } from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import { TbPlus, TbUpload } from "react-icons/tb";

import Animation from "@areas/shared/components/chooseLayout/Animation";
import animationStyles from "@areas/shared/components/chooseLayout/styles/animations.module.css";

import ButtonDanger from "@areas/shared/components/buttons/ButtonDanger";
import CustomModal from "@areas/shared/components/personal/modals/CustomModal";
import CustomModalDelete from "@areas/shared/components/personal/modals/CustomModalDelete";
import { fetchWrapper } from "@helpers/fetchwrapper";

import Table from "./blocks/Table";
import ModalImport from "./blocks/ModalImport";
import {
  initialValues,
  validationSchema,
  confirm,
  ModalBodyAdd,
} from "./blocks/ModalAdd";

function Frame() {
  const [showModal, setShowModal] = useState(false);
  const [showModalView, setShowModalView] = useState(false);
  const [showModalDelete, setShowModalDelete] = useState(false);
  const [showModalImport, setShowModalImport] = useState(false);
  const [headerModal, setHeaderModal] = useState("");
  const [perPage, setPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [data, setData] = useState([]);
  const [load, setLoad] = useState(false);
  const [event, setEvent] = useState(null);
  const [search, setSearch] = useState("");

  const loadData = useCallback(() => {
    setLoad(true);
    const text = encodeURIComponent(search || "");
    fetchWrapper
      .get(
        `/v1/api/app/findEvent?text=${text}&offset=${
          page * perPage - perPage
        }&limit=${perPage}`
      )
      .then((res) => {
        setData(res.data || []);
        setTotal(res.total || 0);
        setLoad(false);
      })
      .catch(() => {
        setData([]);
        setTotal(0);
        setLoad(false);
      });
  }, [page, perPage, search]);

  const handleSearch = useCallback((text) => {
    setSearch(text.trim());
    setPage(1);
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const handlePageChange = (nextPage) => {
    setPage(nextPage);
  };

  const handlePerRowsChange = async (newPerPage, nextPage) => {
    setPerPage(newPerPage);
    setPage(nextPage);
  };

  const toggle = useCallback(
    (item) => {
      if (showModal) {
        setShowModal(false);
        setEvent(null);
      } else {
        setHeaderModal(
          item ? "Редактирование мероприятия" : "Добавление мероприятия"
        );
        setEvent(item || null);
        setShowModal(true);
      }
    },
    [showModal]
  );

  const toggleView = useCallback(
    (item) => {
      if (showModalView) {
        setShowModalView(false);
        setEvent(null);
      } else {
        setEvent(item || null);
        setShowModalView(true);
      }
    },
    [showModalView]
  );

  const toggleDelete = useCallback(
    (item) => {
      if (showModalDelete) {
        setShowModalDelete(false);
        setEvent(null);
      } else {
        setEvent(item);
        setShowModalDelete(true);
      }
    },
    [showModalDelete]
  );

  const handleDelete = () => {
    if (!event) return;
    fetchWrapper
      .post(`/v1/api/admin/deleteevent?idTicket=${event.Id}`, null, false)
      .then(() => {
        setShowModalDelete(false);
        setEvent(null);
        loadData();
      });
  };

  return (
    <div>
      <Animation
        animationIn={animationStyles.fadeIn}
        animationOut={animationStyles.fadeOut}
      >
        <Card>
          <CardHeader>
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Мероприятия компаний</h5>
              <div className="d-flex gap-2">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => setShowModalImport(true)}
                >
                  <TbUpload />
                  Загрузить из Excel
                </button>
                <ButtonDanger onClick={() => toggle()}>
                  <TbPlus />
                  Добавить
                </ButtonDanger>
              </div>
            </div>
          </CardHeader>
          <CardBody>
            <Table
              data={data}
              load={load}
              total={total}
              handlePageChange={handlePageChange}
              handlePerRowsChange={handlePerRowsChange}
              toggleModal={toggle}
              toggleView={toggleView}
              toggleDelete={toggleDelete}
              onSearch={handleSearch}
            />
          </CardBody>
        </Card>
        <CustomModal
          isOpen={showModal}
          toggle={toggle}
          header={headerModal}
          body={(validation) => <ModalBodyAdd validation={validation} />}
          validateYupSchema={validationSchema}
          inititalValues={() => initialValues(event)}
          cancel="Закрыть"
          confirm="Сохранить"
          confirmFunction={(values) => {
            confirm(values, loadData);
          }}
        />
        <CustomModal
          isOpen={showModalView}
          toggle={toggleView}
          header="Просмотр мероприятия"
          body={(validation) => (
            <ModalBodyAdd validation={validation} readOnly />
          )}
          validateYupSchema={validationSchema}
          inititalValues={() => initialValues(event)}
          cancel="Закрыть"
          confirm="Готово"
          confirmFunction={() => {}}
        />
        <CustomModalDelete
          isOpen={showModalDelete}
          onDeleteClick={handleDelete}
          onCloseClick={toggleDelete}
        />
        <ModalImport
          isOpen={showModalImport}
          toggle={() => setShowModalImport(false)}
          onSuccess={loadData}
        />
      </Animation>
    </div>
  );
}

export default Frame;
